'use strict';

window.OptanonWrapper = () => {
    window.OneTrust.OnConsentChanged(() => {
        window.location.reload();
    });
};

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import moduleInit from '@utilities/module-init';

// Import Singletons
import '@utilities/events';
import '@utilities/detect-touch';
import '@utilities/detect-keyboard-focus';
import '@utilities/polyfills';
// import '@utilities/scroll-to';
import '@utilities/in-view';
import '@utilities/load-more';

import '@components/image';
// import '@components/cookies';

// Import modules.
import Carousel from '@components/carousel';
import vacanciesTabs from '@components/vacancies-tabs';
import richTextBlock from '@components/rich-text-block';
import share from '@components/share';
import vacancySearchBar from '@components/vacancy-search-bar';
import generalSearchBar from '@components/general-search-bar';
import { Autocomplete, LabelAsPlaceholder, CustomFile } from '@components/form-elements';
import vacancyFilter from '@components/vacancy-filter';
import stickyApplyBar from '@components/vacancy-short-description';
import processBlock from '@components/process-block';
import { MainNav, LoginNav } from '@components/main-nav';
import FilterDropdown from '@components/filter-dropdown';
import stepForm from '@components/step-form';
import applicationForm from '@components/application-form';
import jobAlertForm from '@components/job-alert-form';
import BrandBanner from '@components/brand-banner';
import Header from '@components/header';
import VacancyOverview from '@components/vacancies-overview';

// Initialize modules.

// Sync
// moduleInit.sync('[js-hook-module-example]', Example);
moduleInit.sync('[js-hook-carousel]', Carousel);
moduleInit.sync('[js-hook-vacancies-tabs]', vacanciesTabs);
moduleInit.sync('[js-hook-rich-text-block]', richTextBlock);
moduleInit.sync('[js-hook-share]', share);
moduleInit.sync('[js-hook-autocomplete]', Autocomplete);
moduleInit.sync('[js-hook-lap]', LabelAsPlaceholder);
moduleInit.sync('[js-hook-input-file]', CustomFile);
moduleInit.sync('[js-hook-vacancy-search-bar]', vacancySearchBar);
moduleInit.sync('[js-hook-general-search-bar]', generalSearchBar);
moduleInit.sync('[js-hook-vacancy-filter]', vacancyFilter);
moduleInit.sync('[js-hook-sticky-apply-bar]', stickyApplyBar);
moduleInit.sync('[js-hook-process-block]', processBlock);
moduleInit.sync('[js-hook-main-nav]', MainNav);
moduleInit.sync('[js-hook-login-nav-wrapper]', LoginNav);
moduleInit.sync('[js-hook-filter-dropdown]', FilterDropdown);
moduleInit.sync('[js-hook-step-form]', stepForm);
moduleInit.sync('[js-hook-application-form]', applicationForm);
moduleInit.sync('[js-hook-job-alert-form]', jobAlertForm);
moduleInit.sync('[js-hook-brand-banner]', BrandBanner);
moduleInit.sync('[js-hook-header]', Header);
moduleInit.sync('[js-hook-vacancy-sort]', VacancyOverview);

// Async
moduleInit.async('[js-hook-modal]', () => import(/* webpackChunkName: "Modal" */ '@components/modal'));
moduleInit.async('[js-hook-tab]', () => import(/* webpackChunkName: "Tabs" */ '@components/tabs'));
moduleInit.async('[js-hook-toggle]', () => import(/* webpackChunkName: "Toggle" */ '@components/toggle'));
